import Col, { ColProps } from 'antd/es/col';
import { clsx } from 'clsx';
import React from 'react';

import s from './AntCol.module.less';

export const AntCol = React.forwardRef<HTMLDivElement, ColProps>((props, ref) => {
  const { ...rest } = props;

  return <Col {...rest} className={clsx(rest.className, s.col)} ref={ref} />;
});

AntCol.displayName = 'AntCol';
